{
  "loading": "載入中…",
  "placeholder": "選取…"
}
